import { AppState } from '../../types/store';
import { ModulePriv } from '../../types/modules';

export const getModuleType = (state: AppState, moduleId) =>
  (state.modules[moduleId] || {}).type;

export const getModuleVersion = (state: AppState, moduleId) =>
  (state.modules[moduleId] || {}).version;

export const getModuleData = (state: AppState, moduleId) =>
  (state.modules[moduleId] || {}).moduleData || {};

export const getModulePrivileges = (state: AppState, moduleId) =>
  (state.modules[moduleId] || {}).privileges || {};

export const getModuleConfig = (state: AppState, moduleId) =>
  (state.modules[moduleId] || {}).moduleConfig || {};

export const getModuleMeta = (state: AppState, moduleId) =>
  (state.modules[moduleId] || {}).moduleMeta || {};

export const getModuleDataByModuleType = (
  state: AppState,
  moduleType: string
) => {
  const moduleRaw = findModules(state, m => m.type === moduleType).pop() || {};
  return moduleRaw.moduleData || {};
};

export const getModuleIdByModuleType = (
  state: AppState,
  moduleType: string
) => {
  const moduleRaw = findModules(state, m => m.type === moduleType).pop() || {};
  return moduleRaw.id || undefined;
};

export const getModules = (state: AppState) => state.modules || {};

export const findModules = (state: AppState, predicate: (m: any) => boolean) =>
  Object.keys(state.modules)
    .filter(key => predicate(state.modules[key]))
    .map(key => state.modules[key]);

export const canPerformModuleAction = (
  state: AppState,
  moduleId: number,
  priv: ModulePriv
) => getModulePrivileges(state, moduleId)[priv] !== false; // assume true by default
